<template>
  <div>
    <carousel :perPage="1" :paginationEnabled="false" on-slide-changed="slideChange($index)">
      <slide>
        <ion-content class="padding">
          <div>
            <p>I keep finding myself seeking, I see someone in the distance with a walk I recognise and I take a breath, but it's never you<br>
            today I went to the listeners story hall, almost relieved to find it was still there<br>
            I arrived before lunch, it was almost empty, I sat in one of the large white spaces, <br>
            I'm not sure for how long<br>
            I think I was waiting for you<br></p>
            <p> &nbsp;</p>
            <p>
            We came here together once, we drank coffee, we ate pastries<br>
            it was the day after we met, do you remember?
            our collision in the market, my bag spilled<br>
            but we laughed, both apologising<br>
            I can see it so clearly now, you found me that day,
            and that day became weeks, and the weeks became months, and in time the two of us became three.</p>
            <p> &nbsp;</p>
            <p>
            and now I remember the water, losing my balance, suddenly below the tideline, <br>
            somehow caught, unable to push up to the surface<br>
            and then hands grabbing me, your hands, </p>
            <p>lifting me<br></p>
            <p>
            you carried me to the shore, </p>
            <p>we said nothing<br></p>
            <p>you held me<br></p>
            <p> &nbsp;</p>
            <p></p>
            <p> &nbsp;
            I carried on sitting in the hall, just staring at the white walls, I don't know how much longer I waited, <br>
            but it was dark when I left, and the street was empty<br>
            in the fading light I could see a perolink crossing the water<br>
            one that wasn't there before<br>
            and a style I didn't recognise, it was high, higher than a plusten, with both sloping ramps as well as steps leading to the top.<br>
            dark green metal on the sides of the walkway<br>
            I should have been surprised, but I hardly flinched<br>
            I've become used to how fluid Portus has become<br></p>
            <p>resigned almost<br></p>
            <p> &nbsp;</p>
            <p>these structures seem to travel so easily from here to wherever and back and forth<br></p>
            <p> &nbsp;
            why can't you?</p>
            <p> &nbsp;</p>
            <p> &nbsp;</p>
          </div>
        </ion-content>
      </slide>
      <slide>
        <ion-content class="padding">
          <div>
            <span class="arch">
              <p>I am stronger. </p>
              <p>Surer. </p>
              <p>I can see the past even though the fog has not lifted, has not cleared the rheum from my eyes, </p>
              <p>I can hear her voice and smell her city. </p>
              <p>I can almost picture her</p>

              <p>I recall journeys taken and the chill of a winters afternoon by the water.
              The sight of a building brings me back to the morning we met, a collision in a crowded market and a bag of vegetables spilling across the paving. </p>
              <p>Eyes meeting and apologising, voices mingling, each saying the same thing. </p>
              <p>CanibuyyouacoffeeCanIbuyyouacoffee? I'msosorryI'msosorry. Ididn'tseeyouIdidn'tseeyou.</p>
              <p>Yesyesyesyesyesyes</p>
              <p>The next afternoon, sitting in the empty white spaces of a listeners story hall, ending up in the cafe with sugared pastries and coffee. </p>
              <p>A day later, walking through the emarket and gifting smiles to everyone we met. </p>
              <p>Then a week later, and the months afterward, days and nights spent talking, reading, writing and dreaming. </p>
              <p>Ducking into closters to hear the chants and leaving just as quickly. </p>
              <p></p>
              <p> &nbsp;</p>
              <p>And the day the waters rose, </p>
              <p> &nbsp;</p>
              <p>and you slipped</p>
              <p> &nbsp;</p>
              <p>I dived after you</p>
              <p> &nbsp;</p>
              <p>and I carried you to the shore,</p>
              <p> &nbsp;</p>
              <p>I felt like a hero, just for one moment, </p>
              <p> &nbsp;</p>
              <p> &nbsp;</p>
              <p>'you saved me'</p>
              <p> &nbsp;</p>
              <p> &nbsp;</p>
              <p>your words</p>
              <p> &nbsp;</p>
              <p></p>
              <p>and now it's me that's adrift</p>
              <p> &nbsp;</p>
              <p> &nbsp;</p>
              <p>I almost forgot any of this happened. </p>
              <p>if I stay here longer then I might forget again.</p>
              <p> &nbsp;</p>
              <p>You and me.  </p>
              <p> &nbsp;</p>
              <p>You and Oska.</p>
              <p> &nbsp;</p>
              <p> &nbsp;</p>
              <p> &nbsp;</p>
            </span>
          </div>
        </ion-content>
      </slide>
    </carousel>
  </div>
</template>

<script>
export default {

  name: '1',

  data () {
    return {
      title: 'Wait'
    }
  }
}
</script>

<style lang="css" scoped>
</style>
